import * as React from "react";
import type { SVGProps } from "react";
const SvgShower = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M13.02 5.09C13.01 5.06 13 5 13 5c0-.55-.45-1-1-1H5c-.55 0-1 .45-1 1v16c0 .55-.45 1-1 1s-1-.45-1-1V5c0-1.65 1.35-3 3-3h7c1.65 0 3 1.35 3 3 0 .015-.005.03-.01.045s-.01.03-.01.045C17.82 5.56 20 8.03 20 11c0 .55-.45 1-1 1H9c-.55 0-1-.45-1-1 0-2.97 2.18-5.44 5.02-5.91ZM14 7c-1.86 0-3.41 1.28-3.86 3h7.72c-.45-1.72-2-3-3.86-3Zm-4.84 6.03c-.53-.15-1.08.17-1.23.7l-.54 2c-.14.53.17 1.08.7 1.23l.025.006c.08.018.153.034.235.034.44 0 .84-.29.96-.74l.54-2c.14-.53-.17-1.08-.7-1.23h.01Zm-1.36 5c-.53-.15-1.08.17-1.23.7l-.54 2c-.14.53.17 1.08.7 1.23l.023.005.05.011.038.008.015.003.021.004h.01l.02.004a.99.99 0 0 0 1.044-.734l.539-2c.14-.53-.17-1.08-.7-1.231h.01Zm14.16 2.7-.54-2a.999.999 0 0 0-1.23-.7c-.53.14-.85.69-.7 1.23l.54 2c.12.45.52.74.96.74.09 0 .17-.01.26-.04.53-.14.85-.69.7-1.23h.01ZM13 19c0-.55.45-1 1-1s1 .45 1 1v2c0 .55-.45 1-1 1s-1-.45-1-1v-2Zm7.61-3.27a.994.994 0 0 1-.7 1.23h-.01a.746.746 0 0 1-.26.04.99.99 0 0 1-.96-.74l-.54-2a.994.994 0 0 1 .7-1.23.999.999 0 0 1 1.23.7l.54 2ZM14 13c-.55 0-1 .45-1 1v2c0 .55.45 1 1 1s1-.45 1-1v-2c0-.55-.45-1-1-1Z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgShower;
